import { useSelector, useDispatch } from 'react-redux'
import { rateSelector, selectedBookingItemSelector, waitingListKeySelector } from 'booking/selectors'
import { makePurchase } from 'booking/actions'
import useBookingValidation from './useBookingValidation'

const useOnPayForParking = () => {
    const rate = useSelector(rateSelector)
    const dispatch = useDispatch()
    const { validateBooking } = useBookingValidation()
    const waitingListKey = useSelector(waitingListKeySelector)
    const selectedBookingItem = useSelector(selectedBookingItemSelector)

    const onPayForParkingClick = (
        inboundNumber,
        outboundNumber,
        additionalServices,
        guestUserPersonalData,
        reservationId
    ) => {
        if (!validateBooking({ purchaseValidation: true })) return
        if (rate?.isOnWaitingList && !waitingListKey) return

        dispatch(
            makePurchase(
                selectedBookingItem,
                inboundNumber,
                outboundNumber,
                additionalServices,
                guestUserPersonalData,
                reservationId
            )
        )
    }

    return { onPayForParkingClick }
}

export default useOnPayForParking
